import { render, staticRenderFns } from "./Campaign2022.vue?vue&type=template&id=7f6596f9"
import script from "./Campaign2022.vue?vue&type=script&lang=js"
export * from "./Campaign2022.vue?vue&type=script&lang=js"
import style0 from "./Campaign2022.vue?vue&type=style&index=0&id=7f6596f9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports